import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/holidays/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_HOLIDAYS]: ({ holidays }) => ({ days: holidays }),
});

export default directOrderRecurring;
